import * as generic from './generic.json'
import * as productDetail from './product-detail.json'
import * as productOverview from './product-overview.json'
import * as abtProductOverview from './abt-product-overview.json'
import * as productFilter from './product-filter.json'
import * as regionSelect from './region-select.json'
import * as cart from './cart.json'
import * as paymentSelection from './payment-selection.json'
import * as abtPayment from './abt-payment.json'
import * as payment from './payment.json'
import * as storeUserLogin from './store-user-login.json'
import * as confirmation from './confirmation.json'
import * as loginForm from './login-form.json'
import * as registrationForm from './registration-form.json'
import * as xcWebsite from './xc-website.json'
import * as subscriptions from './subscriptions.json'
import * as engravedId from './engraved-id.json'
import * as specialSale from './special-sale.json'

export default {
  generic,
  'product-detail': productDetail,
  productOverview,
  abtProductOverview,
  productFilter,
  regionSelect,
  paymentSelection,
  cart,
  payment,
  abtPayment,
  loginForm,
  registrationForm,
  storeUserLogin,
  confirmation,
  'xc-website': xcWebsite,
  subscriptions,
  'engraved-id': engravedId,
  specialSale
}



// WEBPACK FOOTER //
// ./src/locale/en/index.js